import { gql } from '@apollo/client'

export const ANSWER_REFERRED_TO_PURCHASE = gql`
  mutation answerReferredToPurchase($referred: Boolean!) {
    answerReferredToPurchase(referred: $referred) {
      success
    }
  }
`
